<template>
  <div>
    <b-card>
      <main-categories-card />
      <title-text />
      <!--      <summary-content />-->
      <content-text />
      <content-title />
      <content-sub-title />
      <ordering-number />
    </b-card>
    <product-categories-image-card />
  </div>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import TitleText from '@/views/Admin/Product_categories/elements/TitleText.vue'
// import SummaryContent from '@/views/Admin/Product_categories/elements/SummaryContent.vue'
import ContentText from '@/views/Admin/Product_categories/elements/ContentText.vue'
import ContentTitle from '@/views/Admin/Product_categories/elements/ContentTitle.vue'
import ContentSubTitle from '@/views/Admin/Product_categories/elements/ContentSubTitle.vue'
import OrderingNumber from '@/views/Admin/Product_categories/elements/OrderingNumber.vue'
import MainCategoriesCard from '@/views/Admin/Product_categories/elements/MainCategoriesCard.vue'
import ProductCategoriesImageCard from '@/views/Admin/Product_categories/elements/ImageCard.vue'

export default {
  name: 'ItemForm',
  components: {
    ProductCategoriesImageCard,
    MainCategoriesCard,
    BCard,
    TitleText,
    // SummaryContent,
    ContentText,
    ContentTitle,
    ContentSubTitle,
    OrderingNumber,
  },
  computed: {
    itemData() {
      return this.$store.getters['productCategories/dataItem']
    },
  },
}
</script>
